import React, { ComponentType, FC, ReactNode } from 'react';
import { Button } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import { Loaders } from './';

const styles = (theme: Theme) =>
  createStyles({
    button: {
      width: 250,
      marginBottom: theme.spacing(3),
      textAlign: 'center',
    },
    loader: {
      width: 250,
      margin: `0 auto ${theme.spacing(3)}px`,
    },
  });

interface IProps extends WithStyles<typeof styles> {
  text: string | ReactNode;
  working?: boolean;
  onClick?: () => void;
  component?: ComponentType;
  to?: string;
}

const SubmitButton: FC<IProps> = ({ classes, text, working, ...props }) => {
  if (working) {
    return (
      <div className={classes.loader}>
        <Loaders.Standard height={38} />
      </div>
    );
  }

  return (
    <Button
      type="submit"
      className={classes.button}
      size="large"
      variant="contained"
      color="primary"
      disabled={!!working}
      {...props}>
      {text}
    </Button>
  );
};

SubmitButton.defaultProps = {
  working: false,
};

export default withStyles(styles)(SubmitButton);
